var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "legalRuleDetail", "data-role": "page" } },
    [
      _c(
        "div",
        {
          staticClass: "legalRuleDetail-content",
          attrs: { "data-position": "fixed" }
        },
        [
          _c("div", { staticClass: "detailWrap" }, [
            _c("div", { staticClass: "detail-h" }, [
              _c("h3", [
                _c("span", [_vm._v(_vm._s(_vm.Rules.rule_chapter))]),
                _c("br"),
                _c("span", [_vm._v(_vm._s(_vm.Rules.rule_name))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-c" }, [
              _c("h4", { staticClass: "cgyTitle" }, [
                _c("i", { staticClass: "titleIcon icon-law" }),
                _vm._v("法條內容"),
                _vm.Authority
                  ? _c("i", {
                      class: [
                        _vm.Rules.is_keep
                          ? "icon-bookmark-full active"
                          : "icon-bookmark",
                        "bookmarkIcon"
                      ],
                      on: {
                        click: function($event) {
                          _vm.SetFavorites(
                            _vm.Rules.rule_id,
                            _vm.Rules.is_keep,
                            2
                          )
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "cgyContent",
                domProps: { innerHTML: _vm._s(_vm.Rules.content) }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.articles.length > 0
            ? _c("div", { staticClass: "detailWrap articleWrap" }, [
                _c("div", { staticClass: "detail-c" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "cgyContent" }, [
                    _c("div", { staticClass: "articleList" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.articles, function(article, article_ind) {
                          return _c(
                            "li",
                            { key: article_ind },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "newsDetail",
                                      params: { id: article.news_id }
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "topicImg" }, [
                                    article.title_img == ""
                                      ? _c("div", { staticClass: "mainImg" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    article.title_img != ""
                                      ? _c("div", {
                                          staticClass: "mainImg",
                                          style:
                                            "background-image:url(" +
                                            article.title_img +
                                            ")"
                                        })
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "txt-info" }, [
                                    _c(
                                      "span",
                                      { staticClass: "article_desc" },
                                      [_vm._v(_vm._s(article.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "article_date" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            article.news_date.split(" ")[0]
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "metaDiv" }, [
                                      _c("span", { staticClass: "cgy-tag" }, [
                                        _vm._v("法律知識")
                                      ]),
                                      _vm._v(" "),
                                      _vm.Authority
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "bookmark-tag",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  _vm.SetFavorites(
                                                    article.news_id,
                                                    article.is_keep,
                                                    0
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                class: [
                                                  article.is_keep
                                                    ? "icon-bookmark-full active"
                                                    : "icon-bookmark",
                                                  "bookmarkIcon"
                                                ]
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        })
                      ),
                      _vm._v(" "),
                      _vm.now_row <= this.articles.length &&
                      this.articles.length >= 10
                        ? _c(
                            "p",
                            {
                              staticClass: "moreBtn",
                              on: { click: _vm.GetMoreArticles }
                            },
                            [_vm._v("顯示更多")]
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("favoritesToast", {
        attrs: {
          show: _vm.toastControl.show,
          full: _vm.toastControl.full,
          content: _vm.toastControl.content,
          showTime: _vm.toastControl.showTime
        },
        on: {
          close: function($event) {
            _vm.toastControl.show = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "cgyTitle" }, [
      _c("i", { staticClass: "titleIcon icon-article-pen" }),
      _vm._v("相關文章")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fad6974", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fad6974","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/legalRuleDetail.vue
// module id = null
// module chunks = 